export const initialSessionState: SessionState = {
	loader: {
		active: false,
		title: null,
	},
	validated: false,
	messages: [],
	token: null,
};
